import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { TopMenuAPI } from '@business/api/top_menu';
import { TopMenuId, TopMenuResponse, TopMenuSorting } from '@business/entities/top_menu';
import { UserId } from '@business/entities/account';

export class TopMenuBloc extends BaseBloc {
  private readonly topMenuRepo = new Repository<TopMenuResponse>({
    getItemId: topMenu => topMenu.id,
  });

  readonly topMenus$ = this.topMenuRepo.items$;
  readonly selectTopMenu = this.topMenuRepo.selectItem;

  onReset() {
    this.topMenuRepo.reset();
  }

  fetchTopMenus = () => {
    return TopMenuAPI.fetchTopMenus().pipe(this.topMenuRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_top_menu_error') }));
  };

  fetchCompanyTopMenus = () => {
    return TopMenuAPI.fetchCompanyTopMenus().pipe(handleMessage({ error: requestMessage('fetch_top_menu_error') }));
  };

  fetchUserPermissions = (userId: UserId) => {
    return TopMenuAPI.fetchUserPermissions(userId).pipe(
      this.topMenuRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_top_menu_error') }),
    );
  };

  fetchTopMenu = (topMenuId: TopMenuId) => {
    return TopMenuAPI.fetchTopMenu(topMenuId).pipe(this.topMenuRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_top_menu_error') }));
  };

  dashboardPermissions = () => {
    return TopMenuAPI.dashboardPermissions().pipe(this.topMenuRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_top_menu_error') }));
  };

  updateTopMenu = (id: TopMenuId, topMenu: Partial<TopMenuResponse>) => {
    return TopMenuAPI.updateTopMenu(id, topMenu).pipe(this.topMenuRepo.ops.reset(), handleMessage({ type: requestMessage('update_top_menu') }));
  };

  updateTopMenuStatus = (id: TopMenuId, topMenu: Partial<TopMenuResponse>) => {
    return TopMenuAPI.updateTopMenuStatus(id, topMenu).pipe(handleMessage({ type: requestMessage('update_top_menu') }));
  };

  updateUserTopMenuStatus = (id: UserId, topMenu: Partial<TopMenuResponse>) => {
    return TopMenuAPI.updateUserTopMenuStatus(id, topMenu).pipe(handleMessage({ type: requestMessage('update_top_menu') }));
  };

  sortingMenuUpdated = (topMenuSorting: TopMenuSorting) => {
    return TopMenuAPI.sortingMenuUpdated(topMenuSorting).pipe(
      this.topMenuRepo.ops.reset(),
      handleMessage({ type: requestMessage('update_top_menu') }),
    );
  };
}
